<template>
  <quill-editor :options="finalOptions" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name:       "ElsaQuillEditor",
  components: { quillEditor },
  props:      ['options'],
  computed:   {
    finalOptions() {
      return {
        placeholder: 'Введите текст...',
        ...this.options,
      };
    },
  },

};
</script>

<style scoped>

</style>
